var snhuCookie = (function () {

    const GlobalTrackingCookieName = "SNHUGlobalTracking";
    const VenpubIDCookieName = "SNHUvenpubid";
    const GlobalTrackingDomain = "snhu.edu";
    const GlobalTrackingDaysActive = 30;
    const TrackingName = "Tracking";
    const GlobalTrackingParams = ["nan_pid", "ioguid", "k_clickid", "venpubid", "adxcel_clickid", "searchedterm", "pfsegment", "matchtype", "device", "msclid", "gclid"];

    function RenameSearchEngineClickIds(obj) {
        const ClickId = obj['gclid'] || obj['msclid'];
        delete obj['msclid'];
        delete obj['gclid'];
        if (ClickId) {
            obj['ClickId'] = ClickId;
        }
    }

    function GetCookieByName(name) {
        var pos = document.cookie.indexOf(name + '=');
        if (pos == -1) {
            return null;
        } else {
            var pos2 = document.cookie.indexOf(';', pos);
            if (pos2 == -1) {
                return unescape(document.cookie.substring(pos + name.length + 1));
            } else {
                return unescape(document.cookie.substring(pos + name.length + 1, pos2));
            }
        }
    }

    function WriteCookie(cookieValue, cookieName) {
        const date = new Date();
        date.setTime(date.getTime() + (1000 * 60 * 60 * 24 * GlobalTrackingDaysActive));
        document.cookie = `${cookieName}=${cookieValue};expires=${date};path=/;domain=.${GlobalTrackingDomain};`;
    }

    function ExpireCookie(cookieName) {
        const date = new Date();
        date.setTime(date.getTime() - (1000 * 60 * 60 * 24 * GlobalTrackingDaysActive));
        document.cookie = `${cookieName}=;expires=${date};path=/;domain=.${GlobalTrackingDomain};`;
    }

    // Convert a list of objects into a serialized format for the cookie.
    function serialize(list) {
        return list.map((val, i) => `${TrackingName}${i + 1}=${escape(JSON.stringify(val))}`)
            .join('&');
    }

    // Return an array of tracker values from the cookie.
    function deserialize(str) {
        if (!str) {
            return [];
        }
        return str.split('&').reduce((acc, val) => {
            const v = val.split('=');
            const trackerKey = v[0];
            const trackerValue = unescape(v[1]);
            acc.push(JSON.parse(trackerValue));
            return acc;
        }, []);
    }

    function PopulateCookieFromQueryString() {
        // if querystring is empty, don't bother.
        if (!window.location.search) {
            return;
        }

        // Start with what's on the querystring.
        const qs = window.location.search.replace(/^\?/, '').split('&').reduce((acc, val) => {
            const items = val.split('=');
            const k = items[0];
            const v = items[1];
            acc[k] = v;
            return acc;
        }, {});

        const trackingParams = {};

        if (!Object.entries)
            Object.entries = function (obj) {
                var ownProps = Object.keys(obj),
                    i = ownProps.length,
                    resArray = new Array(i); // preallocate the Array
                while (i--)
                    resArray[i] = [ownProps[i], obj[ownProps[i]]];

                return resArray;
            };

        // polyfill method for IE11 and older
        Object.entries(qs).forEach(qsParam => {
            let key = qsParam[0];
            let value = qsParam[1];
            if (GlobalTrackingParams.indexOf(key) > -1) {
                if (value) {
                    trackingParams[key] = value;
                }
            }
        });

        if (Object.entries(trackingParams).length > 0) {
            RenameSearchEngineClickIds(trackingParams);

            const trackerValues = [];//deserialize(trackingCookieValue);
            // Append to the list of trackers
            trackerValues.push(trackingParams);

            // Serialize this
            var trackingCookieValue = serialize(trackerValues);

            // Write to cookie
            WriteCookie(trackingCookieValue, GlobalTrackingCookieName);

            //clear the venpubid in case this string doesn't contain one. We only want to store the most recent click's venpubid
            ExpireCookie(VenpubIDCookieName);
        }

        // If this string contains a venpubid parameter, write the venpubid cookie so we can use it to populate a conversion pixel (WSP-9823)
        if (trackingParams["venpubid"] != null && trackingParams["venpubid"].length > 0) {
            WriteCookie(trackingParams["venpubid"], VenpubIDCookieName);
        }

    }

    function GetQueryStringParameter(name) {
        name = String(name).replace(/[.*+?|()[\]{}\\]/g, '\\$&');
        var match = RegExp('[?&]' + name.toLowerCase() + '=([^&]*)').exec(window.location.search.toLowerCase());
        return match && (decodeURIComponent(match[1].replace(/\+/g, ' ')));
    }

    function ParseReferrerString(referrerString) {
        var arr = referrerString.split('&');
        for (var j = 0; j < arr.length; j++) {
            if (arr[j].replace('?', '').indexOf('utm_source') == 0) {
                $('input#Source,input[name$="Source"]').not('input[name="FormSource"]').val(arr[j].substring(arr[j].indexOf('=') + 1, arr[j].length));
            }
            if (arr[j].replace('?', '').indexOf('utm_medium') == 0) {
                $('input#Medium,input[name$="Medium"]').val(arr[j].substring(arr[j].indexOf('=') + 1, arr[j].length));
            }
            if (arr[j].replace('?', '').indexOf('utm_content') == 0) {
                $('input#Content,input[name$="Content"]').val(arr[j].substring(arr[j].indexOf('=') + 1, arr[j].length));
            }
            if (arr[j].replace('?', '').indexOf('utm_campaign') == 0) {
                $('input#Campaign,input[name$="Campaign"]').not('input[name="SfCampaign"]').val(arr[j].substring(arr[j].indexOf('=') + 1, arr[j].length));
            }
            if (arr[j].replace('?', '').indexOf('SNHU_Segment') == 0) {
                $('input#Segment,input[name$="Segment"]').val(arr[j].substring(arr[j].indexOf('=') + 1, arr[j].length));
            }
            if (arr[j].replace('?', '').indexOf('utm_term') == 0) {
                $('input#Term,input[name$="Term"]').val(arr[j].substring(arr[j].indexOf('=') + 1, arr[j].length));
            }
        }
    }

    function BuildSNHUReferrerCookie() {
        var defaultReferrer = '?utm_source=snhu&utm_medium=webform&utm_content=01&utm_campaign=SNHUEDU&SNHU_Segment=Unknown';
        var source = GetQueryStringParameter('utm_source');
        var medium = GetQueryStringParameter('utm_medium');
        var content = GetQueryStringParameter('utm_content');
        var campaign = GetQueryStringParameter('utm_campaign');
        var segment = GetQueryStringParameter('snhu_segment');
        var term = GetQueryStringParameter('utm_term');
        if (segment == 'null') {
            segment = "ol";
        }

        var currentCookie = GetCookieByName('GoogleString');
        var cookieString = '?utm_source=' + source + '&utm_medium=' + medium + '&utm_content=' + content + '&utm_campaign=' + campaign + '&SNHU_Segment=' + segment + '&utm_term=' + term;

        var date = new Date();
        date.setTime(date.getTime() + (1000 * 60 * 60 * 24 * 2));

        if (source !== null && source != '') {
            WriteCookie(cookieString, 'GoogleString');
            $('input[name$="PageId"],input#PageId').val(cookieString);
            $('input[name$="Source"]').not('input[name="FormSource"]').val(source);
            $('input[name$="Medium"]').val(medium);
            $('input[name$="Campaign"]').not('input[name="SfCampaign"]').val(campaign);
            $('input[name$="Segment"]').val(segment);
            $('input[name$="Content"]').val(content);

        }
        else {
            if (currentCookie !== null) {
                // no query string, but there is a cookie
                $('input[name$="PageId"],input#PageId').val(unescape(currentCookie));
                ParseReferrerString(unescape(currentCookie));
            }
            else {
                try {
                    var gacookie = new gaCookies();
                    var gaString = '?utm_source=' + gacookie.getCampaignSource() + '&utm_medium=' + gacookie.getCampaignMedium() + '&utm_content=' + gacookie.getCampaignContent() + '&utm_campaign=' + gacookie.getCampaignName() + '&utm_term=' + gacookie.getCampaignTerm() + '&SNHU_Segment=';
                    $('input[name$="PageId"],input#PageId').val(gaString);
                    $('input[name$="Source"]').not('input[name="FormSource"]').val(gacookie.getCampaignSource());
                    $('input[name$="Medium"]').val(gacookie.getCampaignMedium());
                    $('input[name$="Campaign"]').not('input[name="SfCampaign"]').val(gacookie.getCampaignName());
                    $('input[name$="Segment"]').val('');
                    $('input[name$="Content"]').val(gacookie.getCampaignContent());
                    ParseReferrerString(gaString);
                }
                catch (err) {
                    try {
                        $('input[name$="PageId"],input#PageId').val(defaultReferrer);
                        ParseReferrerString(defaultReferrer);
                    }
                    catch (e) {
                        if (window.console && typeof (window.console.log) === 'function') {
                            window.console.log(e);
                        }
                    }
                }
            }
        }
    }

    function init() {
        BuildSNHUReferrerCookie();
        PopulateCookieFromQueryString();
    }

    init();

    return {
        GetQueryStringParameter: GetQueryStringParameter
    }

})();